export const breadcrumbItems = [
  {
    id: 0,
    title: "Loan Details",
    url: "../loan-details",
  },
  {
    id: 1,
    title: "Proposed Project",
    url: "../proposed-project",
  },
  {
    id: 2,
    title: "Financial Breakdown",
    url: "../financial-breakdown",
  },
];
